import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MessageUtils } from '../utils/message.utils';
import { ErrorService } from './error.service';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
    constructor(private injector: Injector) {}

    handleError(error: Error | HttpErrorResponse): void {
        // Because the ErrorHandler is created before the providers, we’ll have to use the Injector to get them.
        const messageUtils = this.injector.get(MessageUtils);
        const errorService = this.injector.get(ErrorService);

        // FIXME: conseguir recuperar el stacktrace original, quan falla algo al html (user-detail-dialog-component-html quan no te matInput)

        if (error instanceof HttpErrorResponse) {
            if (!navigator.onLine) {
                messageUtils.showMessage('No Internet connection. Please check your network.');
            } else if (error.status >= 500 && error.status < 600) {
                // Errores de servidor
                messageUtils.showMessage('Service temporarily unavailable. Please try again.');
            } else if (error.status === 0) {
                // Error de red/timeout
                messageUtils.showMessage('Unable to connect to server. Please check your connection.');
            }
        } else {
            // Client-side error
            if (
                !error.message ||
                (error.message && !error.message.includes('ExpressionChangedAfterItHasBeenCheckedError'))
            ) {
                console.error(error);
                // TODO: añadir a las traducciones
                const errorMessage = 'An unexpected error occurred. Please report this to the administrator.';
                messageUtils.showErrorMessage(errorMessage, error);
                errorService.reportError(error);
            }
        }
    }
}
